import Vue from 'vue'
import Router from 'vue-router'
import store from '@/stores/index';

Vue.use(Router)

const SecurityIndex = () => import(/* webpackChunkName: "index" */'@/pages/security/Index')
const UnAuthorized = () => import(/* webpackChunkName: "unauthorized" */'@/pages/UnAuthorized')
const RouterView = () => import(/* webpackChunkName: "router-view" */'@/components/RouterView')
const GeneralConditions = () => import(/* webpackChunkName: "conditions" */'@/pages/legal/GeneralConditions')

const SecurityHome = () => import(/* webpackChunkName: "home-pages" */'@/pages/security/Home')
const SecurityAbout = () => import(/* webpackChunkName: "main-pages" */'@/pages/security/About')
const SecurityFAQ = () => import(/* webpackChunkName: "main-pages" */'@/pages/security/FAQ')
const SecurityContact = () => import(/* webpackChunkName: "main-pages" */'@/pages/security/Contact')
const SecurityReferral = () => import(/* webpackChunkName: "main-pages" */'@/pages/security/Referral')
const SecurityVacancies = () => import(/* webpackChunkName: "main-pages" */'@/pages/security/Vacancies')
const SecurityCity = () => import(/* webpackChunkName: "main-pages" */'@/pages/security/City')
const SecurityAssignment = () => import(/* webpackChunkName: "main-pages" */'@/pages/security/Assignment')
const SecurityPartners = () => import(/* webpackChunkName: "main-pages" */'@/pages/security/Partners')
const SecurityLeidenBioScience = () => import(/* webpackChunkName: "LeidenBioScience" */ '@/pages/security/LeidenBioScience.vue')
const SecurityOperatieBeveiliging = () => import(/* webpackChunkName: "OperatieBeveiliging" */ '@/pages/security/OperatieBeveiliging.vue')
const SecurityCrowdManagement = () => import(/* webpackChunkName: "CrowdManagement" */ '@/pages/security/CrowdManagement.vue')
const SecurityCao = () => import(/* webpackChunkName: "CAO" */ '@/pages/security/Cao.vue')
const SecuritySoftware = () => import(/* webpackChunkName: "Software" */ '@/pages/security/Software.vue')

const SecurityInformation = () => import(/* webpackChunkName: "information-pages" */'@/pages/security/information/Index')
const SecurityInformationProfessional = () => import(/* webpackChunkName: "information-pages" */'@/pages/security/information/Professional')
const SecurityInformationClient = () => import(/* webpackChunkName: "information-pages" */'@/pages/security/information/Client')
const SecurityInformationSecurity = () => import(/* webpackChunkName: "information-pages" */'@/pages/security/information/Security')
const SecurityInformationSecurityDetail = () => import(/* webpackChunkName: "information-pages" */'@/pages/security/information/SecurityDetail')
const SecurityInformationFirstAid = () => import(/* webpackChunkName: "information-pages" */'@/pages/security/information/FirstAid')
const SecurityInformationTrafficSupport = () => import(/* webpackChunkName: "information-pages" */'@/pages/security/information/TrafficSupport')

const Login = () => import(/* webpackChunkName: "account-pages" */'@/pages/account/Login')
const LoginProfessional = () => import(/* webpackChunkName: "account-pages" */'@/pages/account/LoginProfessional')
const LoginClient = () => import(/* webpackChunkName: "account-pages" */'@/pages/account/LoginClient')
const Register = () => import(/* webpackChunkName: "account-pages" */'@/pages/account/Register')
const RegisterProfessional = () => import(/* webpackChunkName: "account-pages" */'@/pages/account/RegisterProfessional')
const RegisterClient = () => import(/* webpackChunkName: "account-pages" */'@/pages/account/RegisterClient')
const ForgotPassword = () => import(/* webpackChunkName: "account-pages" */'@/pages/account/ForgotPassword')
const ResetPassword = () => import(/* webpackChunkName: "account-pages" */'@/pages/account/ResetPassword')
const ConfirmEmail = () => import(/* webpackChunkName: "account-pages" */'@/pages/account/ConfirmEmail')
const Mail = () => import(/* webpackChunkName: "account-pages" */'@/pages/account/SendEmail')

const ClientProfileIndex = () => import(/* webpackChunkName: "client-profile-pages" */'@/pages/client/profile/Index')
const ClientProfileOverview = () => import(/* webpackChunkName: "client-profile-pages" */'@/pages/client/profile/Overview')
const ClientProfilePayment = () => import(/* webpackChunkName: "client-profile-pages" */'@/pages/client/profile/Payment')
const ClientProfileReferral = () => import(/* webpackChunkName: "professional-profile-pages" */'@/pages/client/profile/Referral')
const ClientProfileManagers = () => import(/* webpackChunkName: "professional-profile-pages" */'@/pages/client/profile/Managers')
const ClientProfileCredits = () => import(/* webpackChunkName: "professional-profile-pages" */'@/pages/client/profile/Credits')

const ProfessionalProfileIndex = () => import(/* webpackChunkName: "professional-profile-pages" */'@/pages/professional/profile/Index')
const ProfessionalProfileOverview = () => import(/* webpackChunkName: "professional-profile-pages" */'@/pages/professional/profile/Overview')
const ProfessionalProfileRates = () => import(/* webpackChunkName: "professional-profile-pages" */'@/pages/professional/profile/Rates')
const ProfessionalProfileEducations = () => import(/* webpackChunkName: "professional-profile-pages" */'@/pages/professional/profile/Educations')
const ProfessionalProfileWorkArea = () => import(/* webpackChunkName: "professional-profile-pages" */'@/pages/professional/profile/WorkArea')
const ProfessionalProfilePassManager = () => import(/* webpackChunkName: "professional-profile-pages" */'@/pages/professional/profile/PassManager')
const ProfessionalProfilePayment = () => import(/* webpackChunkName: "professional-profile-pages" */'@/pages/professional/profile/Payment')
const ProfessionalProfilePassRequest = () => import(/* webpackChunkName: "professional-profile-pages" */'@/pages/professional/profile/PassRequest')
const ProfessionalProfileReferral = () => import(/* webpackChunkName: "professional-profile-pages" */'@/pages/professional/profile/Referral')
const ProfessionalProfileCredits = () => import(/* webpackChunkName: "professional-profile-pages" */'@/pages/professional/profile/Credits')

const ProfileProfessionalWizard = () => import(/* webpackChunkName: "professional-profile-wizard-pages" */'@/pages/professional/profile/wizard/Index')
const ProfileClientWizard = () => import(/* webpackChunkName: "client-profile-wizard-pages" */'@/pages/client/profile/wizard/Index')

const ClientDashboard = () => import(/* webpackChunkName: "client-pages" */'@/pages/client/Dashboard')
const ClientAssignments = () => import(/* webpackChunkName: "client-pages" */'@/pages/client/Assignments')
const ClientPlanning = () => import(/* webpackChunkName: "client-pages" */'@/pages/client/Planning')
const ClientRequest = () => import(/* webpackChunkName: "client-pages" */'@/pages/client/Request')
const ClientProgress = () => import(/* webpackChunkName: "client-pages" */'@/pages/client/Progress')
const ClientActivities = () => import(/* webpackChunkName: "client-pages" */'@/pages/client/Activities')

const ProfessionalDashboard = () => import(/* webpackChunkName: "professional-pages" */'@/pages/professional/Dashboard')
const ProfessionalAssignments = () => import(/* webpackChunkName: "professional-pages" */'@/pages/professional/Assignments')
const ProfessionalProgress = () => import(/* webpackChunkName: "professional-pages" */'@/pages/professional/Progress')
const ProfessionalCalendar = () => import(/* webpackChunkName: "professional-pages" */'@/pages/professional/Calendar')
const ProfessionalWebshop = () => import(/* webpackChunkName: "professional-pages" */'@/pages/professional/Webshop')

const ProfessionalAssignment = () => import(/* webpackChunkName: "professional-assignment-pages" */'@/pages/professional/Assignment')
const ProfessionalAssignmentDescription = () => import(/* webpackChunkName: "professional-assignment-pages" */'@/pages/professional/assignment/Description')
const ProfessionalAssignmentChat = () => import(/* webpackChunkName: "professional-assignment-pages" */'@/pages/professional/assignment/Chat')
const ProfessionalAssignmentReport = () => import(/* webpackChunkName: "professional-assignment-pages" */'@/pages/professional/assignment/Report')
const ProfessionalAssignmentReview = () => import(/* webpackChunkName: "professional-assignment-pages" */'@/pages/professional/assignment/Review')
const ProfessionalAssignmentPayment = () => import(/* webpackChunkName: "professional-assignment-pages" */'@/pages/professional/assignment/Payment')

const ClientAssignment = () => import(/* webpackChunkName: "Client-assignment-pages" */'@/pages/client/Assignment')
const ClientAssignmentDescription = () => import(/* webpackChunkName: "Client-assignment-pages" */'@/pages/client/assignment/Description')
const ClientAssignmentChat = () => import(/* webpackChunkName: "Client-assignment-pages" */'@/pages/client/assignment/Chat')
const ClientAssignmentReport = () => import(/* webpackChunkName: "Client-assignment-pages" */'@/pages/client/assignment/Report')
const ClientAssignmentReview = () => import(/* webpackChunkName: "Client-assignment-pages" */'@/pages/client/assignment/Review')
const ClientAssignmentPayment = () => import(/* webpackChunkName: "Client-assignment-pages" */'@/pages/client/assignment/Payment')

const ifProfessional = (to, from, next) => {
    if(store.getters.type.toLowerCase() == "professional")
        return next();
    return next({ name: "UnAuthorized" });
}

const ifClient = (to, from, next) => {
    if(store.getters.type.toLowerCase() == "client")
        return next();
    return next({ name: "UnAuthorized" });
}

const isIE = () => {
    const ua = navigator.userAgent;
    /* MSIE used to detect old browsers and Trident used to newer ones*/
    const is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

    return is_ie; 
}


const router = new Router({
    mode: 'history',
    linkActiveClass: "active",
    routes: [
        { 
            path: "*", 
            //redirect: "/security",
            beforeEnter(to, from, next) {
                if(!to.fullPath.endsWith(".html") || to.fullPath.endsWith("app.html")|| to.fullPath.endsWith("index.html"))
                    return next("/security-beveiligingsbedrijf")
            }
        },
        { 
            path: "/", 
            redirect: { name: "Security" },
            meta: {

            }
        },
        {
            path: "/unauthorized", 
            name: 'UnAuthorized',
            component: UnAuthorized, 
            meta: {
                title: 'Geen Toegang',
                canonical: 'https://azurity.nl/unauthorized'
            },
        },
        {
            path: "/security-beveiligingsbedrijf", 
            alias: "/security",
            redirect: { name: 'SecurityHome' },
            name: 'Security',
            component: SecurityIndex, 
            children: [
                { //home
                    path: "", 
                    alias: "home",
                    name: 'SecurityHome',
                    component: SecurityHome, 
                    meta: {
                        title: 'Beveiligingsbedrijf | Beveiliging - Verkeersregelaars - EHBO',
                        auth: false,
                        canonical: 'https://azurity.nl/security-beveiligingsbedrijf'
                    },
                },
                { //about
                    path: "over-azurity", 
                    alias: "about",
                    name: 'SecurityAbout',
                    component: SecurityAbout, 
                    meta: {
                        title: 'Over Azurity',
                        canonical: 'https://azurity.nl/security-beveiligingsbedrijf/about',
                        description: 'Azurity is, als officieel beveiligingsbedrijf dat is erkent door het Ministerie van Justitie, het grootste platform voor beveiligers.',
                        keywords: 'Beveiligingsbedrijf, Azurity, Beveiliging, Platform, Justitie, Beveiligers, Beveiligingsdiensten, EHBO-ers, Verkeersregelaars, Referral'
                    },
                },
                { //faq
                    path: "veel-gestelde-vragen", 
                    alias: "faq",
                    name: 'SecurityFAQ',
                    component: SecurityFAQ, 
                    meta: {
                        title: 'Veelgestelde vragen',
                        canonical: 'https://azurity.nl/security-beveiligingsbedrijf/veel-gestelde-vragen',
                        description: 'Veel gestelde vragen over Azurity Beveiliging en het Platform. Pas-management, vergunning, snelle administratie, zoek & boek, rapportages, reviews.',
                        keywords: 'Beveiligingsbedrijf, Azurity, Beveiliging, Veelgesteld, Vragen, FAQ, Platform, Justitie, Beveiligers, Beveiligingsdiensten, EHBO-ers, Verkeersregelaars, Referral'
                    },
                },
                { //contact
                    path: "contact", 
                    name: 'SecurityContact',
                    component: SecurityContact, 
                    meta: {
                        title: 'Contact',
                        canonical: 'https://azurity.nl/security-beveiligingsbedrijf/contact',
                        description: 'Neem vrijblijvend contact op met Azurity Beveiliging voor nadere kennismaking en of een offerteaanvraag. info@azurity.nl',
                        keywords: 'Beveiligingsbedrijf, Azurity, Beveiliging, Contact, Vragen, Kennismaking, Informatie, Platform, Justitie, Beveiligers, Beveiligingsdiensten, EHBO-ers, Verkeersregelaars, Referral, info@azurity.nl'
                    },
                },
                { //about
                    path: "referral", 
                    name: 'SecurityReferral',
                    component: SecurityReferral, 
                    meta: {
                        title: 'Referral Programma',
                        canonical: 'https://azurity.nl/security-beveiligingsbedrijf/referral',
                        description: 'Verwijs je een opdrachtgever of beveiliger door naar het erkende beveiligingsbedrijf Azurity dan willen we daar graag wat voor terug doen door daar een financiele vergoeding voor te geven.',
                        keywords: 'Beveiligingsbedrijf, Azurity, Beveiliging, Referral, Verwijs, Doorverwijzen, Informatie, Platform, Justitie, Beveiligers, Beveiligingsdiensten, EHBO-ers, Verkeersregelaars, info@azurity.nl'
                    },
                },
                { //assignment
                    path: "assignment", 
                    name: 'SecurityAssignment',
                    component: SecurityAssignment, 
                    meta: {
                        title: 'Open Opdracht',
                        canonical: 'https://azurity.nl/security-beveiligingsbedrijf/assignment'
                    },
                },
                { //assignment
                    path: "partners", 
                    name: 'SecurityPartners',
                    component: SecurityPartners, 
                    meta: {
                        title: 'Partners | Rijnland Beveiliging | Veiligheidsteam',
                        canonical: 'https://azurity.nl/security-beveiligingsbedrijf/partners',
                        description: "Rijnland beveiging en Veiligheidsteam zijn partners van het beveiligingsbedrijf Azurity. Kantoorhoudende in Leiden en Oegstgeest.",
                        keywords: "Partner, Rijnland, Beveiliging, Veiligheidsteam, Beveiligingsbedrijf, Leiden, Oegstgeest"
                    },
                },
                { //collectieve-beveiliging-leidenbiosciencepark
                    path: "collectieve-beveiliging", 
                    alias: "collectieve-beveiliging-leidenbiosciencepark", 
                    name: 'LeidenBioScience',                  
                    component: SecurityLeidenBioScience,
                    meta: {
                        title: 'Collectieve Beveiliging',
                        canonical: 'https://azurity.nl/security-beveiligingsbedrijf/collectieve-beveiliging',
                        description: 'Collectieve beveiliging en bewaking op Leiden, Oegstgeest en Leiderdorp door erkend beveiligingsbedrijf. Permanent preventief toezicht.',
                        keywords: 'Beveiligingsbedrijf, collectief, beveiliging, bewaking, leiden, bio, science, park, preventief, brand- en sluitronde, nachtbewaking'
                    },
                },
                { //operatie-beveiliging
                    path: "operatie-beveiliging", 
                    name: 'OperatieBeveiliging',
                    component: SecurityOperatieBeveiliging,
                    meta: {
                        title: 'Veiligheid staat voorop | Operatie Beveiliging',
                        canonical: 'https://azurity.nl/security-beveiligingsbedrijf/operatie-beveiliging',
                        description: 'Operatie Beveiliging volgt verschillende beveiligers tijdens hun werk en geeft een unieke en exclusieve kijk achter de schermen bij verschillende grote en kleine evenementen in Nederland.',
                        keywords: 'operatie, beveiliging, bewaking, leiden, evenement, veiligheid, sbs6'
                    },
                },
                { //crowd-management
                    path: "crowd-management", 
                    name: 'CrowdManagement',
                    component: SecurityCrowdManagement,
                    meta: {
                        title: 'Crowd Manamgement',
                        canonical: 'https://azurity.nl/security-beveiligingsbedrijf/crowd-management',
                        description: 'Bij crowd management gaat het om systematisch analyseren en door gerichte maatregelen het reduceren van risico\'s die ontstaan wanneer zich een grote groep mensen ergens verzamelen.',
                        keywords: 'crowd, management, publiek, risico, beveiliging, bewaking, leiden, evenement, veiligheid, sociologie, massapsychologie, calamiteiten, evacuatie, ontruiming'
                    },
                },
                { //software
                    path: "branche-software",
                    alias: "software", 
                    name: 'Software',
                    component: SecuritySoftware,
                    meta: {
                        title: 'Software voor de beveilingsbranche | Online Administratie | Innovatief',
                        canonical: 'https://azurity.nl/security-beveiligingsbedrijf/branche-software',
                        description: 'Online platform/software speciaal voor particuliere beveiligingsbedrijven en beveiligers. Volledig compliant aan de Wet particuliere beveiligingsorganisaties en recherchebureaus (WPBR).',
                        keywords: 'software, beveiliging, platform, wpbr, wetgeving, partculier, beveilingsbedrijf, branche, aanmelden, korpschef, politie, identity, app, handhaving, wpbr, rpbr, bpbr'
                    },
                },
                { //cao
                    path: "cao-beveiliging", 
                    name: 'CAO',
                    component: SecurityCao,
                    meta: {
                        title: 'CAO Beveiliging',
                        canonical: 'https://azurity.nl/security-beveiligingsbedrijf/cao-beveiliging',
                        description: 'Download hier de vigerende CAO beveiliging  van de Nederlandse Veiligheidsbranche.',
                        keywords: 'cao, beveiliging, bewaking, veiligheid, collectief, arbeidsovereenkomst'
                    },
                    beforeEnter: (to, from, next) => {
                        let year = (new Date()).getFullYear();
                        to.meta.title = 'CAO Beveiliging ' + year;
                        to.meta.description = 'Download hier de vigerende CAO beveiliging ' + year + ' van de Nederlandse Veiligheidsbranche.';
                        return next();
                    }
                },
                { //information
                    path: "informatie",
                    alias: "information", 
                    name: 'Information',
                    component: SecurityInformation, 
                    meta: {
                        title: 'Informatie',
                        canonical: 'https://azurity.nl/security-beveiligingsbedrijf/information'
                    },
                    children: [
                        { 
                            path: "opdrachtgever-of-beveiligingsbedrijf", 
                            alias: "opdrachtgever",
                            name: 'InformationClient',
                            component: SecurityInformationClient, 
                            meta: {
                                title: 'Informatie Opdrachtgever',
                                canonical: 'https://azurity.nl/security-beveiligingsbedrijf/information/opdrachtgever',
                                description: 'Maak een opdracht, zoek een beveiliger, brandwachten, verkeersregelaar of EHBO-er voor uw evenement, pand of een ander project en relax.',
                                keywords: 'Azurity, Beveiliging, Veiligheid, Veiligheidsprofessional, Screening, Direct Contact, Slim Zoeken, Wij Luisteren, Verkeersregelaar, EHBO'
                            }
                        },
                        { 
                            path: "beveiliger-verkeersregelaar-ehbo", 
                            alias: "professional",
                            name: 'InformationProfessional',
                            component: SecurityInformationProfessional, 
                            meta: {
                                title: 'Informatie Beveiliger, Verkeersregelaar of EHBO-er',
                                canonical: 'https://azurity.nl/security-beveiligingsbedrijf/information/professional',
                                description: 'Vind beveiligings opdrachten, altijd zeker van je betaling of je nou in loondienst of als freelancer werkt.',
                                keywords: 'Azurity, Beveiliging, Veiligheid, Veiligheidsprofessional, Flexibel Tarief, Werkgeied, Slimme Kalender, Contract, Verkeersregelaar, EHBO'
                            }
                        },
                        { 
                            path: "beveiliging", 
                            name: 'InformationSecurity',
                            component: SecurityInformationSecurity, 
                            meta: {
                                title: 'Informatie Beveiliging',
                                canonical: 'https://azurity.nl/security-beveiligingsbedrijf/information/beveiliging',
                                image: 'https://azurity.nl/img/guard-scanner-600.b31128c9.png'
                            }
                        },
                        { 
                            path: "beveiliging/:detail", 
                            name: 'InformationSecurityDetail',
                            component: SecurityInformationSecurityDetail, 
                            meta: {
                                title: 'Informatie Beveiliging',
                                canonical: 'https://azurity.nl/security-beveiligingsbedrijf/information/beveiliging/',
                                image: 'https://azurity.nl/img/guard-scanner-600.b31128c9.png',
                                description: null,
                                keywords: null
                            },
                            beforeEnter: (to, from, next) => {
                                let detail = (to.params.detail.substring(0,1).toUpperCase() + to.params.detail.substring(1,to.params.detail.length));
                                to.meta.title = detail + ' | Informatie Beveiliging';
                                to.meta.canonical = 'https://azurity.nl/security-beveiligingsbedrijf/information/beveiliging/' + to.params.detail;
                                to.meta.description = detail + ' | Azurity Beveiliging & Bewaking levert o.a. ' + to.params.detail + '. Azurity is een beveiligingsbedrijf. Wij leveren beveiligers, verkeersregelaars en EHBO-ers.';
                                to.meta.keywords = detail + ', Beveiliging, Bewaking, Beveiliger, Security, Beveiliginsbedrijf, Objectbeveiliging, Winkelsurveillance, Evenementenbeveiliging, Receptiediensten, Brandwachten, Verkeersregelaars, EHBO'; 
                                return next();
                            },
                        },
                        { 
                            path: "ehbo", 
                            name: 'InformationFirstAid',
                            component: SecurityInformationFirstAid, 
                            meta: {
                                title: 'Informatie EHBO',
                                canonical: 'https://azurity.nl/security-beveiligingsbedrijf/information/ehbo/',
                                description: 'Altijd een gecertificeerde professional in de buurt met Eerste Hulp Bij Ongelukken (EHBO).',
                            }
                        },
                        { 
                            path: "verkeersregelaars", 
                            name: 'InformationTrafficSupport',
                            component: SecurityInformationTrafficSupport, 
                            meta: {
                                title: 'Informatie Verkeersregelaars',
                                canonical: 'https://azurity.nl/security-beveiligingsbedrijf/information/verkeersregelaars/',
                                image: 'https://azurity.nl/img/traffic-600.2a26932e.png',
                                description: 'Een verkeersregelaar is in Nederland een persoon die de bevoegdheid heeft om instructies op te dragen aan weggebruikers.'
                            }
                        }
                    ]
                },
                { //vacancies
                    path: "werken-in-de-beveiliging",
                    alias: "vacancies", 
                    name: 'SecurityVacancies',
                    component: SecurityVacancies, 
                    meta: {
                        title: 'Werken bij Azurity',
                        canonical: 'https://azurity.nl/security-beveiligingsbedrijf/information/vacancies/',
                        description: 'Regelmatig zijn wij opzoek naar nieuwe professionals, zowel ZZP, dienstverband bij ons of zo nu en dan een klus via je eigen werkgever.',
                        keywords: 'werken, werk bij ons, beveiliger, verkeersregelaar, brandwacht, ehbo-er, werkenbij@azurity.nl, sollicitaties'
                    },
                },
                { //voorwaarden
                    path: "voorwaarden", 
                    name: 'GeneralConditions',
                    component: GeneralConditions, 
                    meta: {
                        title: 'Algemene Voorwaarden',
                        canonical: 'https://azurity.nl/security-beveiligingsbedrijf/voorwaarden/'
                    },
                },
                { //city
                    path: "plaats/:city/:detail?", 
                    name: 'SecurityCity',
                    component: SecurityCity, 
                    meta: {
                        title: 'Huur Een Beveiliger',
                        canonical: 'https://azurity.nl/security-beveiligingsbedrijf/plaats/Leiden',
                        description: null,
                        keywords: null
                    },
                    beforeEnter: (to, from, next) => {
                        let city = (to.params.city.substring(0,1).toUpperCase() + to.params.city.substring(1,to.params.city.length));
                        to.meta.title = city + ' | Beveiligingsbedrijf | Huur Een Beveiliger';
                        to.meta.canonical = 'https://azurity.nl/security-beveiligingsbedrijf/plaats/' + to.params.city;

                        let description = city;
                        if(!!to.params.detail)
                        {
                            to.meta.title = city + " | " + to.params.detail + " | Beveiligingsbedrijf | Huur Een Beveiliger";
                            to.meta.canonical = to.meta.canonical + "/" + to.params.detail;
                            description += " | " + to.params.detail;
                        }
                        
                        to.meta.description = description + ' |  Beveiliging & Bewaking | Beveiligingsbedrijf Azurity is werkzaam in de regio ' + city + '. Azurity is een beveiligingsbedrijf dat beveiligers, verkeersregelaars en EHBO-ers levert.';
                        to.meta.keywords = city + ', Beveiliging, Bewaking, Beveiliger, Security, Beveiliginsbedrijf, Objectbeveiliging, Winkelsurveillance, Evenementenbeveiliging, Receptiediensten, Brandwachten, Verkeersregelaars, EHBO'; 
                        return next();
                    },
                },
                { //account
                    path: "account", 
                    name: 'Account',
                    component: RouterView,
                    meta: {
                        title: 'Aanmelden of Inloggen',
                        canonical: 'https://azurity.nl/account/'
                    },
                    children:
                    [
                        {
                            path: "forgotpassword", 
                            name: 'ForgotPassword',
                            component: ForgotPassword, 
                            meta: {
                                title: 'Wachtwoord Vergeten?',
                                canonical: 'https://azurity.nl/account/forgotpassword'
                            },
                        },
                        {
                            path: "resetpassword", 
                            name: 'ResetPassword',
                            component: ResetPassword, 
                            meta: {
                                title: 'Wachtwoord Reset',
                                canonical: 'https://azurity.nl/account/resetpassword'
                            }
                        },
                        {
                            path: "confirmemail/:userid", 
                            name: 'ConfirmEmail',
                            component: ConfirmEmail, 
                            meta: {
                                title: 'Email bevestigen',
                                canonical: 'https://azurity.nl/account/confirmemail'
                            }
                        },
                        {
                            path: "login", 
                            name: 'Login',
                            component: Login, 
                            meta: {
                                title: 'Inloggen',
                                canonical: 'https://azurity.nl/account/login'
                            },
                            children: 
                            [
                                {
                                    path: "professional", 
                                    name: 'LoginProfessional',
                                    component: LoginProfessional, 
                                    meta: {
                                        title: 'Inloggen Beveiliger',
                                        canonical: 'https://azurity.nl/account/login/professional'
                                    },
                                },
                                {
                                    path: "client", 
                                    name: 'LoginClient',
                                    component: LoginClient, 
                                    meta: {
                                        title: 'Inloggen Opdrachtgever',
                                        canonical: 'https://azurity.nl/account/login/client'
                                    },
                                }
                            ]
                        },
                        {
                            path: "register", 
                            name: 'Register',
                            component: Register, 
                            meta: {
                                title: 'Aanmelden',
                                canonical: 'https://azurity.nl/account/register'
                            },
                            children: 
                            [
                                {
                                    path: "professional/:type?", 
                                    name: 'RegisterProfessional',
                                    component: RegisterProfessional, 
                                    meta: {
                                        title: 'Aanmelden Beveiliger',
                                        canonical: 'https://azurity.nl/account/register/professional'
                                    },
                                },
                                {
                                    path: "client", 
                                    name: 'RegisterClient',
                                    component: RegisterClient, 
                                    meta: {
                                        title: 'Aanmelden Opdrachtgever',
                                        canonical: 'https://azurity.nl/account/register/client'
                                    },
                                }
                            ]
                        }
                    ]
                },
                { //client
                    path: "client", 
                    name: 'Client',
                    component: ClientDashboard,
                    meta: {
                        title: 'Dashboard | Opdrachtgever',
                        auth: true,
                    },
                    beforeEnter: ifClient,
                    children: [
                        {
                            path: "wizard", 
                            name: 'ClientWizard',
                            component: ProfileClientWizard, 
                            meta: {
                                title: 'Profiel Wizard | Opdrachtgever',
                            },
                            beforeEnter: ifClient,
                            children: []
                        },
                        {
                            path: "dashboard", 
                            name: 'ClientDashboard',
                            component: ClientDashboard, 
                            meta: {
                                title: 'Dashboard | Opdrachtgever',
                            },
                            children: []
                        },
                        {
                            path: "assignment/:id", 
                            name: 'ClientAssignment',
                            component: ClientAssignment, 
                            redirect: { name: 'ClientAssignmentDescription' },
                            children: [
                                {
                                    path: "description", 
                                    name: 'ClientAssignmentDescription',
                                    component: ClientAssignmentDescription, 
                                    meta: {
                                        title: 'Opdracht | Opdrachtgever',
                                    },
                                    children: [],
                                },
                                {
                                    path: "chat", 
                                    name: 'ClientAssignmentChat',
                                    component: ClientAssignmentChat, 
                                    meta: {
                                        title: 'Opdracht | Berichten | Opdrachtgever',
                                    },
                                    children: [],
                                },
                                {
                                    path: "report", 
                                    name: 'ClientAssignmentReport',
                                    component: ClientAssignmentReport, 
                                    meta: {
                                        title: 'Opdrachten | Rapportage | Opdrachtgever',
                                    },
                                    children: [],
                                },
                                {
                                    path: "review", 
                                    name: 'ClientAssignmentReview',
                                    component: ClientAssignmentReview, 
                                    meta: {
                                        title: 'Opdrachten | Review | Opdrachtgever',
                                    },
                                    children: [],
                                },
                                {
                                    path: "payment", 
                                    name: 'ClientAssignmentPayment',
                                    component: ClientAssignmentPayment, 
                                    meta: {
                                        title: 'Opdrachten | Betaling | Opdrachtgever',
                                    },
                                    children: [],
                                },
                            ]
                        },
                        {
                            path: "assignments", 
                            name: 'ClientAssignments',
                            component: ClientAssignments, 
                            meta: {
                                title: 'Opdrachten | Opdrachtgever',
                            },
                            children: []
                        },
                        {
                            path: "planning", 
                            name: 'ClientPlanning',
                            component: ClientPlanning, 
                            meta: {
                                title: 'Planning | Opdrachtgever',
                            },
                            children: []
                        },
                        {
                            path: "request", 
                            name: 'ClientRequest',
                            component: ClientRequest, 
                            meta: {
                                title: 'Aanvraag | Opdrachtgever',
                            },
                            children: []
                        },
                        {
                            path: "progress", 
                            name: 'ClientProgress',
                            component: ClientProgress, 
                            meta: {
                                title: 'Voortgang | Opdrachtgever',
                            },
                            children: []
                        },
                        {
                            path: "hiring", 
                            name: 'ClientActivities',
                            component: ClientActivities, 
                            meta: {
                                title: 'Inhuur | Opdrachtgever',
                            },
                            children: []
                        },
                        { //profile
                            path: "profile", 
                            name: 'ClientProfile',
                            component: ClientProfileIndex, 
                            meta: {
                                title: 'Profiel | Beveiliger',
                            },
                            redirect: { name: 'ClientProfileOverview' },
                            children: [
                                {
                                    path: "overview", 
                                    name: 'ClientProfileOverview',
                                    component: ClientProfileOverview, 
                                    meta: {
                                        title: 'Profiel | Opdrachtgever',
                                    },
                                },
                                {
                                    path: "payment", 
                                    name: 'ClientProfilePayment',
                                    component: ClientProfilePayment, 
                                    meta: {
                                        title: 'Profiel | Opdrachtgever | Betalingen',
                                    },
                                },
                                {
                                    path: "managers", 
                                    name: 'ClientProfileManagers',
                                    component: ClientProfileManagers, 
                                    meta: {
                                        title: 'Profiel | Opdrachtgever | Leidinggevenden',
                                    },
                                },
                                {
                                    path: "credits", 
                                    name: 'ClientProfileCredits',
                                    component: ClientProfileCredits, 
                                    meta: {
                                        title: 'Profiel | Opdrachtgever | Credits',
                                    },
                                },
                                {
                                    path: "referral", 
                                    name: 'ClientProfileReferral',
                                    component: ClientProfileReferral, 
                                    meta: {
                                        title: 'Profiel | Opdrachtgever | Referral Programma',
                                    },
                                }
                            ]
                        }
                    ]
                },
                { //professional
                    path: "professional", 
                    name: 'Professional',
                    component: ProfessionalDashboard, 
                    meta: {
                        title: 'Dashboard | Beveiliger',
                        auth: true,
                    },
                    beforeEnter: ifProfessional,
                    children: [
                        {
                            path: "assignment/:id", 
                            name: 'ProfessionalAssignment',
                            component: ProfessionalAssignment, 
                            meta: {
                                title: 'Opdracht | Beveiliger',
                            },
                            redirect: { name: 'ProfessionalAssignmentDescription' },
                            children: [
                                {
                                    path: "description", 
                                    name: 'ProfessionalAssignmentDescription',
                                    component: ProfessionalAssignmentDescription, 
                                    meta: {
                                        title: 'Opdracht | Beveiliger',
                                    },
                                    children: [],
                                },
                                {
                                    path: "chat", 
                                    name: 'ProfessionalAssignmentChat',
                                    component: ProfessionalAssignmentChat, 
                                    meta: {
                                        title: 'Opdracht | Berichten | Beveiliger',
                                    },
                                    children: [],
                                },
                                {
                                    path: "report", 
                                    name: 'ProfessionalAssignmentReport',
                                    component: ProfessionalAssignmentReport, 
                                    meta: {
                                        title: 'Opdrachten | Rapportage | Beveiliger',
                                    },
                                    children: [],
                                },
                                {
                                    path: "review", 
                                    name: 'ProfessionalAssignmentReview',
                                    component: ProfessionalAssignmentReview, 
                                    meta: {
                                        title: 'Opdrachten | Review | Beveiliger',
                                    },
                                    children: [],
                                },
                                {
                                    path: "payment", 
                                    name: 'ProfessionalAssignmentPayment',
                                    component: ProfessionalAssignmentPayment, 
                                    meta: {
                                        title: 'Opdrachten | Betaling | Beveiliger',
                                    },
                                    children: [],
                                },
                            ]
                        },
                        {
                            path: "assignments", 
                            name: 'ProfessionalAssignments',
                            component: ProfessionalAssignments, 
                            meta: {
                                title: 'Opdrachten | Beveiliger',
                            },
                            children: [],
                        },
                        {
                            path: "calendar", 
                            name: 'ProfessionalCalendar',
                            component: ProfessionalCalendar, 
                            meta: {
                                title: 'Kalender | Beveiliger',
                            },
                            children: [],
                        },
                        {
                            path: "progress", 
                            name: 'ProfessionalProgress',
                            component: ProfessionalProgress, 
                            meta: {
                                title: 'Voorgang | Beveiliger',
                            },
                            children: [],
                        },
                        {
                            path: "webshop", 
                            name: 'ProfessionalWebshop',
                            component: ProfessionalWebshop, 
                            meta: {
                                title: 'Webshop | Beveiliger',
                            },
                            children: [],
                        },
                        { //profile
                            path: "profile", 
                            name: 'ProfessionalProfile',
                            component: ProfessionalProfileIndex, 
                            meta: {
                                title: 'Profiel | Beveiliger',
                            },
                            redirect: { name: 'ProfessionalProfileOverview' },
                            children: [
                                {
                                    path: "overview", 
                                    name: 'ProfessionalProfileOverview',
                                    component: ProfessionalProfileOverview, 
                                    meta: {
                                        title: 'Profiel | Beveiliger',
                                    },
                                },
                                {
                                    path: "rates", 
                                    name: 'ProfessionalProfileRates',
                                    component: ProfessionalProfileRates, 
                                    meta: {
                                        title: 'Profiel | Beveiliger | Tarieven',
                                    },
                                },
                                {
                                    path: "educations", 
                                    name: 'ProfessionalProfileEducations',
                                    component: ProfessionalProfileEducations, 
                                    meta: {
                                        title: 'Profiel | Beveiliger | Opleidingen',
                                    },
                                },
                                {
                                    path: "workarea", 
                                    name: 'ProfessionalProfileWorkArea',
                                    component: ProfessionalProfileWorkArea, 
                                    meta: {
                                        title: 'Profiel | Beveiliger | Werkgebied',
                                    },
                                },
                                {
                                    path: "passmanager", 
                                    name: 'ProfessionalProfilePassManager',
                                    component: ProfessionalProfilePassManager, 
                                    meta: {
                                        title: 'Profiel | Beveiliger | Pas Manager',
                                    },
                                },
                                {
                                    path: "payment", 
                                    name: 'ProfessionalProfilePayment',
                                    component: ProfessionalProfilePayment, 
                                    meta: {
                                        title: 'Profiel | Beveiliger | Betalingen',
                                    },
                                },
                                {
                                    path: "pass-request", 
                                    name: 'ProfessionalProfilePassRequest',
                                    component: ProfessionalProfilePassRequest, 
                                    meta: {
                                        title: 'Profiel | Beveiliger | WPBR Pas',
                                    },
                                },
                                {
                                    path: "referral", 
                                    name: 'ProfessionalProfileReferral',
                                    component: ProfessionalProfileReferral, 
                                    meta: {
                                        title: 'Profiel | Beveiliger | Referral Programma',
                                    },
                                },
                                {
                                    path: "credits", 
                                    name: 'ProfessionalProfileCredits',
                                    component: ProfessionalProfileCredits, 
                                    meta: {
                                        title: 'Profiel | Beveiliger | Credits',
                                    },
                                }
                            ]
                        },
                        { //profile-wizard
                            path: "profile/wizard", 
                            name: 'ProfessionalWizard',
                            component: ProfileProfessionalWizard, 
                            meta: {
                                title: 'Profiel Wizard | Beveiliger',
                            },
                        },
                    ]
                }
            ]
        },
        { 
            path: "/client/assignment", 
            name: 'Assignment',
            component: ClientAssignment, 
            meta: {
                title: 'Nieuwe Opdracht',
            },
            beforeEnter: ifClient,
            children: [ ]
        },
    ]
});

router.beforeEach((to, from, next) => {
    //document.title = "Azurity | " + to.meta.title;

    if(!!Object.keys(from.query).length && !Object.keys(to.query).length)
    {
        next({name: to.name, query: from.query});
    }
    
    if(to.matched.some((c) => { return c.meta.auth }))
    {
        if(store.getters.isAuthenticated) {
            if(!store.getters.user.isCompleted)
            {
                if(to.name.toLowerCase() != store.getters.type.toLowerCase() + 'wizard')
                {
                    return next({ name: store.getters.type + "Wizard" });
                }
            }
            return next();
        } else 
        {
            return store.dispatch('AUTH_LOGOUT').then(() => {
                return next({ name: "Login" });
            });
        }
    } else if(store.getters.isAuthenticated && to.name != 'ConfirmEmail')
    {
        if(!to.matched.some((c) => { return c.meta.auth }))
        {
            return next({ name: store.getters.type });
        }
    }
    return next();
});

router.afterEach((to, from) => {
    setTimeout(() => {
        if(isIE())
        {
            window.scroll(0, 0);
        } else {
            window.scroll({
                top: 0, 
                left: 0, 
                behavior: 'smooth'
            })
        }
    },1);
})
export default router;